import * as React from 'react';

import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { IAppPropsWithRoute } from '../../common/types';
import TermsWidget from './termsWidget'
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import LoginOTP from './LoginOTP';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { ILoginState } from './types/authTypes';
import {formatToken, getRoles} from './loginHelpers'

interface LoginPageProps extends IAppPropsWithRoute {
};

const useStyles = makeStyles((theme: Theme) => ({

}));

function LoginPage(props: LoginPageProps): JSX.Element {
    const dispatch = useDispatch();
    const dispatchThunk = useDispatch<ThunkDispatch<any, any, Action>>();
    const classes = useStyles();

    const initialLoginState: ILoginState = {
        Step: 0,
        Username: '',
        Password: '',
        isSMS: false
    }
    const [loginState, setLoginState] = useState<ILoginState>(initialLoginState);

    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [])



    const navigate = (isSuccess: boolean, token: string) => {
        if (isSuccess) {
            props.history.push('/');
        }
    }

    const finishLogin = (isSuccess: boolean, token: string): void => {
        navigate(isSuccess, token);
    }

    const goToForgotPassword = () => {
        props.history.push('/reset-password'); // TODO add ForgotPassword route
    }

    const goToLoginOTP = (username: string, password: string, isSMS: boolean): void => {
        setLoginState({
            Step: 1,
            Username: username,
            Password: password,
            isSMS
        })
    }

    const handleFinishLoginOTP = (isSuccess: boolean, token: string): void => {
        navigate(isSuccess, token);
    }

    const createLoginControl = (): JSX.Element => {
        if (loginState.Step == 0) {
            return (<TermsWidget finishLogin={finishLogin} goToForgotPassword={goToForgotPassword} goToLoginOTP={goToLoginOTP} />);
        }
        else {
            return <LoginOTP finishLoginOTP={handleFinishLoginOTP} username={loginState.Username} password={loginState.Password} dispatch={dispatchThunk} isSMS={loginState.isSMS} />
        }
    }

    return (
        <div>
            {createLoginControl()}
        </div>
    );
}

export default React.memo(withRouter(LoginPage)) 
